import { atomWithStorage } from 'jotai/utils'

// Default feature flag values
const flags = {
  enableRemapUI: true,
}

export const featureFlagsAtom = atomWithStorage('featureFlags', flags)
